/* custom-cl-experts2 — Heights big-photo rail.
   CSS owns scroll-snap + the peek layout. JS adds only what CSS can't:
   (1) pointer drag-to-scroll, (2) prev/next arrow paging with disabled-state sync.
   Idempotent (safe on Theme-Editor re-render) via a per-node init flag. */
(function () {
  'use strict';

  function initRail(wrap) {
    if (wrap.dataset.clXp2Ready === '1') return;
    wrap.dataset.clXp2Ready = '1';

    var rail = wrap.querySelector('[data-cl-xp2-rail]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-cl-xp2-prev]');
    var next = wrap.querySelector('[data-cl-xp2-next]');

    function step() {
      var card = rail.querySelector('.cl-xp2__card');
      if (!card) return rail.clientWidth * 0.8;
      var styles = getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 24;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      var atStart = rail.scrollLeft <= 2;
      var atEnd = rail.scrollLeft >= max;
      // Edge state drives the CSS fade mask: without it the peeking card is cut dead
      // at the viewport edge mid-word and reads as broken text, not as "there is more".
      wrap.dataset.clXp2Edge = max <= 2 ? 'none' : atStart ? 'start' : atEnd ? 'end' : 'mid';
      if (!prev || !next) return;
      prev.disabled = atStart;
      next.disabled = atEnd;
    }

    if (prev && next) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    rail.addEventListener('scroll', sync, { passive: true });
    sync();
    // arrow bounds shift on resize (card width tracks viewport)
    window.addEventListener('resize', sync, { passive: true });

    /* ---- pointer drag-to-scroll (desktop; native touch handles fine on mobile) ---- */
    var down = false, moved = false, startX = 0, startScroll = 0;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;      // let native momentum handle touch
      if (e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 4) return;     // tolerance before we claim the gesture
      if (!moved) {
        moved = true;
        rail.classList.add('is-dragging');
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      }
      rail.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function endDrag(e) {
      if (!down) return;
      down = false;
      if (moved) {
        rail.classList.remove('is-dragging');
        try { rail.releasePointerCapture(e.pointerId); } catch (err) {}
        // suppress the click that fires on the child the drag ended over
        rail.addEventListener('click', swallowClick, true);
        sync();
      }
    }
    function swallowClick(e) {
      e.stopPropagation();
      e.preventDefault();
      rail.removeEventListener('click', swallowClick, true);
    }

    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('pointerleave', endDrag);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-cl-xp2]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify Theme Editor: re-init a section when it is added / re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
